import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const Ethnical = () => {
  return (
    <Container>


    <h2 className="display-6 fw-bold my-4">
    Ethical peer-reviewing

    </h2>
    <hr />
   
      <p className="joab-common-para my-2 ">
      To avoid such conflicts of interest of peer-reviewers, we require referees to disclose any professional and commercial competing interests before undertaking to review a paper.
      </p>
      <p className="joab-common-para my-2 ">
      Only after disclosure an invited peer-reviewer will receive the manuscript for reading and peer-reviewing. If an invited peer-reviewer is not able (are willing) to declare a potential conflict of interest, the peer-reviewer will be rejected.
      </p>
     
   
    

  </Container>
  );
};

export default Ethnical;
